import React from 'react';
import { Link } from 'react-router-dom'

const Loading = (props) => {
    return (
        <div id="Loading" className="page1 noAnimate">
            <div className="wrapper">
                <div className='loadingLayout'>
                    <p>Loading...</p>
                    <div className="meter">
                        <span xstyle="width:90%;">
                            <span className="progressAnimated"></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Loading;

